import lf from 'lovefield'

export function const_cubaturestypes_const_phases (schemaBuilder) {
  schemaBuilder.createTable('const_cubaturestypes_const_phases')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('const_cubaturestypes_id', lf.Type.INTEGER)
      .addColumn('const_phase_id', lf.Type.INTEGER)
      .addColumn('depart', lf.Type.INTEGER)
      .addColumn('arrivee', lf.Type.INTEGER)
      .addPrimaryKey(['id']);
}

/*
CREATE TABLE IF NOT EXISTS `const-cubaturestypes` (
  `code` varchar(3) NOT NULL,
  `nom` varchar(20) NOT NULL,
  PRIMARY KEY (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constCubaturestypesconstPhases.schema.js